import LaboratoryStateMixin from '@/modules/laboratoryModule/mixins/laboratoryStateMixin'
import { ENTITIES_LABORATORY } from '@/modules/laboratoryModule/config/sidebarConfig'
import { commonDeviceService } from '@/api/services/common/device/common-device.service'
import { uniq } from 'lodash'

export default {
    name: 'InstrumentsMixin',
    mixins: [
        LaboratoryStateMixin
    ],
    data() {
        return {
            instrumentSelected: null,
            instrumentOptions: []
        }
    },
    methods: {
        resetInstrumentsData() {
            this.instrumentSelected = null
            this.instrumentOptions = []
        },
        _selectedElementAssayIds(selectedRows) {
            if (!!selectedRows?.length && this.selectedOption.type === ENTITIES_LABORATORY.SUBPORTION) {
                return uniq(selectedRows.map(subportion => subportion.assay.id))
            }
        },
        async loadInstrumentOptions(selectedRows) {
            if (selectedRows?.length) {
                const supportedOperationTypes = [ENTITIES_LABORATORY.PORTION, ENTITIES_LABORATORY.SUBPORTION]
                if (!supportedOperationTypes.includes(this.selectedOption.type)) {
                    return
                }

                const params = {
                    sectionIds: this.sectionIds,
                    operations: [this.selectedOption.id],
                    assayIds: this._selectedElementAssayIds(selectedRows, this.selectedOption)
                }
                const [error, response] = await this.toCall(commonDeviceService.search(this.$store.getters.labId, params))
                if (error) {
                    this.showErrorModalGlobalFromErrorResponse(error)
                    this.instrumentOptions = []
                }
                this.instrumentOptions = response
            }
        }
    }
}
